import { Button, Box, Text } from "@postenbring/hedwig-react";

export const ServiceButtons = ({ buttons, contact, viewPort }) => (
    <div className={`bring-service-buttons ${viewPort === 'mobile' ? 'bring-service-buttons-mobile' : 'bring-service-buttons-desktop'}`}>
        {contact &&
            <Box className="bring-service-contact-box hds-mb-24-32">
                <Text variant="h3" className="hds-mb-16">{contact.contactTitle}</Text>
                <Text as="p" variant="body">{contact.contactLead}</Text>
                {contact.contactButton && contact.contactButton.length > 0 &&
                <Button variant="primary" className="hds-mt-16" fullWidth asChild>
                    <a href={contact.contactButton[0].href} target={contact.contactButton[0].target}>{contact.contactButton[0].text}</a>
                </Button>
                }
            </Box>
        }
        {buttons && buttons.length > 0 &&
            <div className="hds-mb-24-32">
                {buttons.map((button, index) => (
                    <Button
                        key={index}
                        variant={index > 0 ? "secondary" : "primary"}
                        className="hds-mb-16"
                        fullWidth
                        asChild
                    >
                        <a href={button.href} target={button.target}>{button.text}</a>
                    </Button>
                ))}
            </div>

        }
    </div>

);
